import { FIREBASE_COLLECTION_KEY_BANNERS } from '../../consts'

const Firebase = window?.['firebase']

const {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_AUTH_DOMAIN,
    REACT_APP_FIREBASE_DATABASE_URL,
    REACT_APP_FIREBASE_PROJECT_ID,
    REACT_APP_FIREBASE_STORAGE_BUCKET,
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    REACT_APP_FIREBASE_APP_ID,
} = window.APP_CONFIG

/**
 * Init Firebase libs with config
 */
export const initFirebase = () => {
    const firebaseConfig = {
        apiKey: REACT_APP_FIREBASE_API_KEY,
        authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
        projectId: REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: REACT_APP_FIREBASE_APP_ID,
    }

    if (!Firebase) {
        // eslint-disable-next-line no-console
        console.error('Firebase not defined')
        return
    }

    Firebase.initializeApp(firebaseConfig)
}

/**
 * Init Firestore and fetch banners for entites. After that cache it and disable connection to Firestore for
 * manipulate with cached data.
 */
export const initFirestore = () => {
    const firestore = Firebase?.firestore?.()

    if (!firestore) {
        // eslint-disable-next-line no-console
        console.error('Firebase Firebastore not defined')
        return
    }

    firestore.enablePersistence({
        synchronizeTabs: true,
    })

    firestore
        .collection(FIREBASE_COLLECTION_KEY_BANNERS)
        .get()
        .then(() => firestore.disableNetwork())
}
